import React from 'react';
import { Box, Card, CardContent, Skeleton } from '@mui/material';

interface ShimmerCardProps {
  variant?: 'roadmap' | 'timeline' | 'statistics';
}

const ShimmerCard: React.FC<ShimmerCardProps> = ({ variant = 'roadmap' }) => {

  if (variant === 'roadmap') {
    return (
      <Card elevation={1}>
        <CardContent>
          <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="90%" height={20} />
          <Skeleton variant="text" width="80%" height={20} />
          <Skeleton variant="text" width="40%" height={16} sx={{ mt: 1 }} />
        </CardContent>
      </Card>
    );
  }

  if (variant === 'timeline') {
    return (
      <Card elevation={1}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
            <Skeleton variant="circular" width={40} height={40} />
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="50%" height={28} />
              <Skeleton variant="text" width="30%" height={20} />
            </Box>
          </Box>
          <Skeleton variant="rectangular" width="100%" height={60} sx={{ mb: 1, borderRadius: 1 }} />
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Skeleton variant="rounded" width={80} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Box>
        </CardContent>
      </Card>
    );
  }

  if (variant === 'statistics') {
    return (
      <Card elevation={1}>
        <CardContent>
          <Skeleton variant="text" width="40%" height={28} sx={{ mb: 2 }} />
          <Skeleton variant="rectangular" width="100%" height={300} sx={{ borderRadius: 1 }} />
        </CardContent>
      </Card>
    );
  }

  return null;
};

export default ShimmerCard;
